export default __webpack_public_path__ + "static/media/exp_tiffany_v18.87981847.glb";